export { default as Header } from './Header';
export { default as Welcome } from './Welcome';
export { default as ProjectsList } from './ProjectsList';
export { default as Project } from './Project';
export { default as Landing } from './Landing/Landing';
export {
  AddAddress,
  AddProviders,
  AddressCard,
  NewProject,
  Share,
  Why,
  EditAddresses,
} from './ModalBodies';



// WEBPACK FOOTER //
// ./src/view/screens/index.js